import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PhilReportService extends ApiService {
  public fetchPhaseOneStateWise(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.PHASE_ONE_REPORT,
      {
        params: reqData,
      }
    );
  }
  public fetchPhaseThreeDetails(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.PHASE_TWO_REPORT,
      {
        params: reqData,
      }
    );
  }
  public fetchRejectionReport(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.REJECTION_REPORT,
      {
        params: reqData,
      }
    );
  }
  public fetchRejectionReportUserWise(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.REJECTION_REPORT_USERWISE,
      {
        params: reqData,
      }
    );
  }
  public fetchLeaderBoard(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.DASHBOARD_LEADERBOARD,
      {
        params: reqData,
      }
    );
  }
  public fetchLeaderBoardDetails(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.DASHBOARD_LEADERBOARD_DETAILS,
      {
        params: reqData,
      }
    );
  }
  public fetchReachReport(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.REACH_REPORT,
      {
        params: reqData,
      }
    );
  }
  public fetchWorkerList(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.WORKER_LIST,
      {
        params: reqData,
      }
    );
  }
  public fetchStats(): Observable<any> {
    return this.get<any>(ROUTES.MY_STATS
    );
  }
  public fetchRitwikReport(obj: any): Observable<any> {
    return this.post<any>(ROUTES.wORKER_REPORT,
      {
        body: obj,
      }
    );
  }
  public fetchLanguageList(): Observable<any> {
    return this.get<any>(ROUTES.LANGUAGE_LIST)
  }
  public fetchWorkerCert(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.WORKER_CERT,
      {
        params: reqData,
      }
    );
  }
  public fetchWorkerInfo(fc: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.WORKER_DETAILS, {
        fc,
      }),

    );
  }
    public fetch1DpGlobal10StatisticsData(params:any): Observable<any>{
    return this.get<any>(ROUTES.BANGLADESH_1_O_ALL_DATA, {params})
  }
}

